import { render, staticRenderFns } from "./NumerationTitleComponent.vue?vue&type=template&id=1092f898"
import script from "./NumerationTitleComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumerationTitleComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NumerationTitleComponent.vue?vue&type=style&index=0&id=1092f898&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1092f898')) {
      api.createRecord('1092f898', component.options)
    } else {
      api.reload('1092f898', component.options)
    }
    module.hot.accept("./NumerationTitleComponent.vue?vue&type=template&id=1092f898", function () {
      api.rerender('1092f898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Numeration/NumerationTitleComponent.vue"
export default component.exports